/**
 * These codes are taken directly from the spec page and can vary across browsers / OS's in certain instances
 * See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/code/code_values for more info
 * Additional keys and key groupings can be added here as necessary
 */
export var KeyCodes;
(function (KeyCodes) {
    // Modifier Keys
    // Lock Keys
    // Navigation Keys
    KeyCodes["ArrowRight"] = "ArrowRight";
    KeyCodes["ArrowDown"] = "ArrowDown";
    KeyCodes["ArrowLeft"] = "ArrowLeft";
    KeyCodes["ArrowUp"] = "ArrowUp";
    KeyCodes["Home"] = "Home";
    KeyCodes["End"] = "End";
    KeyCodes["PageDown"] = "PageDown";
    KeyCodes["PageUp"] = "PageUp";
    KeyCodes["Escape"] = "Escape";
    // Editing Keys
    KeyCodes["Enter"] = "Enter";
    KeyCodes["Space"] = "Space";
    KeyCodes["Backspace"] = "Backspace";
    KeyCodes["Tab"] = "Tab";
    KeyCodes["Delete"] = "Delete";
    // Contextual Keys
    // Numeric Keys
    KeyCodes["Digit0"] = "Digit0";
    KeyCodes["Digit1"] = "Digit1";
    KeyCodes["Digit2"] = "Digit2";
    KeyCodes["Digit3"] = "Digit3";
    KeyCodes["Digit4"] = "Digit4";
    KeyCodes["Digit5"] = "Digit5";
    KeyCodes["Digit6"] = "Digit6";
    KeyCodes["Digit7"] = "Digit7";
    KeyCodes["Digit8"] = "Digit8";
    KeyCodes["Digit9"] = "Digit9";
    // Character Keys
})(KeyCodes || (KeyCodes = {}));
// export type CharacterKeys =
//# sourceMappingURL=KeyCodes.js.map